import React from "react";
import SeoHead from "../components/SeoHead";

export default function AboutPage() {
  return (
    <article>
      <SeoHead
        title="About"
        description="Paysafi is building the simplest rent management platform for African landlords. Learn about our mission and the team behind the product."
        path="/about"
      />
      <section className="border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-900 py-16 sm:py-20">
        <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
            About Paysafi
          </h1>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400">
            We're building the simplest rent management platform for African landlords.
          </p>
        </div>
      </section>
      <section className="py-14 sm:py-20">
        <div className="mx-auto max-w-3xl px-4 sm:px-6">
          <div className="prose prose-gray max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Our mission</h2>
            <p className="mt-4 text-gray-600 dark:text-gray-400 leading-relaxed">
              Rent collection in Kenya is still largely manual, done through phone calls, notebooks, and
              WhatsApp messages. Landlords lose money to late payments, forget who paid, and spend
              hours doing admin work instead of growing their portfolio.
            </p>
            <p className="mt-4 text-gray-600 dark:text-gray-400 leading-relaxed">
              Paysafi was built to fix that. We give landlords a modern, easy to use dashboard that
              tracks every tenant, every payment, and every outstanding balance automatically.
              When tenants are late, Paysafi follows up with SMS reminders and AI phone calls so
              landlords don't have to.
            </p>

            <h2 className="mt-12 text-2xl font-bold text-gray-900 dark:text-white">Why Kenya first</h2>
            <p className="mt-4 text-gray-600 dark:text-gray-400 leading-relaxed">
              Kenya has over 2 million rental units managed by individual landlords. Most don't use
              any software at all. We designed Paysafi specifically for this market: KES denominated,
              East African Time, M-Pesa ready (coming soon), and built for mobile first access.
            </p>

            <h2 className="mt-12 text-2xl font-bold text-gray-900 dark:text-white">Our values</h2>
            <ul className="mt-4 space-y-3">
              {[
                ["Simplicity first", "If a landlord can't figure it out in 3 minutes, we've failed."],
                ["Built for Africa", "Pricing, currency, time zones, and workflows designed for the market."],
                ["Transparent", "No hidden fees, no surprise charges, no lock in."],
                ["Relentless on reliability", "Your data is safe. The app works even on slow connections."],
              ].map(([title, desc]) => (
                <li key={title} className="text-gray-600 dark:text-gray-400">
                  <span className="font-semibold text-gray-900 dark:text-white">{title}</span>: {desc}
                </li>
              ))}
            </ul>

          </div>
        </div>
      </section>
    </article>
  );
}
